import { useState, useEffect } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen relative">
      {/* New Background */}
      <div className="fixed inset-0 z-0 bg-gradient-to-br from-[#36090d] via-[#5a0f15] to-[#36090d]">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#e97e89] rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#f1b2b9] rounded-full filter blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#e97e89] rounded-full filter blur-3xl animate-pulse delay-500"></div>
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10">
        {/* Navigation - Sticky */}
        <nav className={`fixed top-0 left-0 right-0 z-50 shadow-md border-b border-white/20 backdrop-blur-md transition-all duration-300 ${
          isScrolled ? 'bg-[#36090d]/90 h-14' : 'bg-transparent h-16'
        }`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className={`flex justify-between items-center transition-all duration-300 ${
              isScrolled ? 'h-14' : 'h-16'
            }`}>
              <div className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/448d3dd4920f14db0013cfc0f3d75a62/51fa198fcc5d92a2ecc7c07e6e02f260.png"
                  alt="Orvia Logo"
                  className={`transition-all duration-300 ${
                    isScrolled ? 'h-7 sm:h-8' : 'h-8 sm:h-10'
                  }`}
                />
              </div>
              
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-8">
                  <a href="/" className="text-white hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Home
                  </a>
                  <a href="/chi-siamo" className="text-white/80 hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Chi Siamo
                  </a>
                  <a href="/contatti" className="text-white/80 hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Contatti
                  </a>
                </div>
              </div>

              <div className="md:hidden">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="text-white hover:text-[#e97e89] p-2"
                >
                  <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile menu */}
          {isMenuOpen && (
            <div className="md:hidden bg-[#36090d]/95 backdrop-blur-md">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-white/20">
                <a href="/" className="text-white block px-4 py-3 text-base font-medium rounded-lg hover:bg-white/10">
                  Home
                </a>
                <a href="/chi-siamo" className="text-white/80 hover:text-[#e97e89] block px-4 py-3 text-base font-medium rounded-lg hover:bg-white/10">
                  Chi Siamo
                </a>
                <a href="/contatti" className="text-white/80 hover:text-[#e97e89] block px-4 py-3 text-base font-medium rounded-lg hover:bg-white/10">
                  Contatti
                </a>
              </div>
            </div>
          )}
        </nav>

        {/* Hero Section */}
        <section className="relative py-16 sm:py-20 lg:py-32 pt-24 sm:pt-32">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
              <div className="text-left order-2 lg:order-1">
                <h1 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-white mb-4 sm:mb-6 leading-tight tracking-wider uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Orvia – Costruiamo la tua presenza digitale, 
                  <span className="text-[#e97e89]"> un pixel alla volta</span>
                </h1>
                
                <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-8 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Trasformiamo idee in esperienze online. Dallo sviluppo web alla gestione social, 
                  il nostro obiettivo è dare forza e identità al tuo brand nel mondo digitale.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <a href="/contatti" className="bg-[#e97e89] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold hover:bg-[#36090d] transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-md hover:shadow-lg transform hover:-translate-y-1 text-sm sm:text-base">
                    Richiedi un preventivo gratuito
                  </a>
                  <button className="border-2 border-[#e97e89] text-[#e97e89] px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold hover:bg-[#e97e89] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg transform hover:-translate-y-1 text-sm sm:text-base">
                    Scopri i nostri servizi
                  </button>
                </div>
              </div>
              
              <div className="relative flex justify-center items-center order-1 lg:order-2">
                {/* Logo Orvia come elemento decorativo */}
                <div className="relative">
                  <img 
                    src="https://static.readdy.ai/image/448d3dd4920f14db0013cfc0f3d75a62/51fa198fcc5d92a2ecc7c07e6e02f260.png"
                    alt="Orvia Logo"
                    className="w-48 h-48 sm:w-64 sm:h-64 lg:w-96 lg:h-96 object-contain opacity-90 drop-shadow-2xl"
                  />
                  
                  {/* Effetto glow sottile attorno al logo */}
                  <div className="absolute inset-0 w-48 h-48 sm:w-64 sm:h-64 lg:w-96 lg:h-96 bg-[#e97e89]/20 rounded-full blur-3xl -z-10"></div>
                  
                  {/* Elementi decorativi attorno al logo */}
                  <div className="absolute -top-2 -right-2 sm:-top-4 sm:-right-4 w-6 h-6 sm:w-8 sm:h-8 bg-[#e97e89]/60 rounded-full animate-pulse"></div>
                  <div className="absolute -bottom-3 -left-3 sm:-bottom-6 sm:-left-6 w-4 h-4 sm:w-6 sm:h-6 bg-[#f1b2b9]/60 rounded-full animate-pulse delay-1000"></div>
                  <div className="absolute top-1/2 -right-4 sm:-right-8 w-3 h-3 sm:w-4 sm:h-4 bg-white/40 rounded-full animate-pulse delay-500"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="py-12 sm:py-16 lg:py-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6 sm:mb-8 tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Benvenuto in Orvia
              </h2>
              
              <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6 text-base sm:text-lg text-white/90 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                <p>
                  Benvenuto in <strong className="text-[#e97e89]">Orvia</strong>, la tua agenzia digitale di fiducia specializzata nello sviluppo di siti web professionali, 
                  nella creazione di strategie di comunicazione digitale e nella gestione dei social media.
                </p>
                
                <p>
                  Siamo un team di esperti che unisce creatività, tecnologia e visione strategica per dare forma alla tua presenza online.
                </p>
                
                <p>
                  Nel mondo di oggi, avere un sito web non è più sufficiente: serve un ecosistema digitale coerente, 
                  capace di attrarre, coinvolgere e convertire.
                </p>
                
                <p>
                  Ecco perché Orvia nasce con una missione chiara: <em className="text-[#e97e89] font-semibold italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                  creare soluzioni digitali su misura, pensate per far crescere la tua attività e valorizzare la tua identità online.
                  </em>
                </p>
                
                <p className="text-lg sm:text-xl font-semibold text-white">
                  Con Orvia, la tua presenza digitale diventa più visibile, più veloce e più efficace.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-12 sm:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-4 sm:mb-6 tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                💡 Cosa Facciamo
              </h2>
              
              <p className="text-base sm:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed"
                 style={{ fontFamily: 'Lato, sans-serif' }}>
                Orvia è una web agency completa, con una specializzazione principale nello sviluppo web personalizzato. 
                Non creiamo solo siti belli da vedere, ma strumenti di crescita concreti per il tuo business.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
              {/* Service 1 */}
              <div className="p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-code-s-slash-line text-xl sm:text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-extrabold text-white mb-3 sm:mb-4 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  🔧 Sviluppo Web Professionale
                </h3>
                <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Creiamo siti web su misura, responsive e ottimizzati per le performance. 
                  Dalla landing page al portale complesso, ogni progetto è pensato per convertire.
                </p>
              </div>

              {/* Service 2 */}
              <div className="p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-palette-line text-xl sm:text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-extrabold text-white mb-3 sm:mb-4 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  🎨 Design UX/UI e Brand Identity
                </h3>
                <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Progettiamo esperienze utente coinvolgenti e identità visive memorabili. 
                  Il design non è solo estetica, ma strategia di comunicazione.
                </p>
              </div>

              {/* Service 5 */}
              <div className="p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-quill-pen-line text-xl sm:text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-extrabold text-white mb-3 sm:mb-4 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  💬 Copywriting e Comunicazione
                </h3>
                <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Scriviamo contenuti che parlano al tuo pubblico e convertoni. 
                  Ogni parola è pensata per raccontare la tua storia nel modo giusto.
                </p>
              </div>

              {/* Service 6 - Additional */}
              <div className="p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-line-chart-line text-xl sm:text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-extrabold text-white mb-3 sm:mb-4 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  📊 Analytics e Consulenza
                </h3>
                <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Monitoriamo le performance e forniamo consulenza strategica per ottimizzare continuamente i risultati.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Web Development Detail Section */}
        <section className="py-12 sm:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-4 sm:mb-6 tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                💻 Sviluppo Web – Il Cuore di Orvia
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-white/90 max-w-4xl mx-auto leading-relaxed"
                 style={{ fontFamily: 'Lato, sans-serif' }}>
                Siamo specializzati nello sviluppo di siti web professionali su misura.
                Dalle piccole imprese alle grandi realtà, creiamo progetti unici che uniscono estetica, usabilità e performance.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-12 sm:mb-16">
              <div className="p-6 sm:p-8 rounded-2xl shadow-md border border-white/20 hover:bg-[#e97e89]/15 hover:border-[#e97e89]/50 transition-all duration-300">
                <div className="flex items-start mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-window-line text-lg sm:text-xl text-[#e97e89]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-extrabold text-white mb-2 sm:mb-3 tracking-wide uppercase"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      🔹 Siti vetrina aziendali
                    </h3>
                    <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                       style={{ fontFamily: 'Lato, sans-serif' }}>
                      Perfetti per aziende, liberi professionisti e brand emergenti che vogliono presentarsi in modo professionale e coerente.
                      Ogni sito è responsive, ottimizzato SEO e personalizzato in base alla tua identità.
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-6 sm:p-8 rounded-2xl shadow-md border border-white/20 hover:bg-[#36090d]/25 hover:border-[#36090d]/50 transition-all duration-300">
                <div className="flex items-start mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-shopping-cart-line text-lg sm:text-xl text-[#e97e89]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-extrabold text-white mb-2 sm:mb-3 tracking-wide uppercase"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      🔹 E-commerce personalizzati
                    </h3>
                    <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                       style={{ fontFamily: 'Lato, sans-serif' }}>
                      Costruiamo negozi online performanti, sicuri e intuitivi.
                      Utilizziamo le migliori piattaforme — WooCommerce, Shopify, Prestashop o soluzioni custom — integrando sistemi di pagamento, gestione ordini e analisi vendite.
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-6 sm:p-8 rounded-2xl shadow-md border border-white/20 hover:bg-[#e97e89]/15 hover:border-[#e97e89]/50 transition-all duration-300">
                <div className="flex items-start mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-file-text-line text-lg sm:text-xl text-[#e97e89]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-extrabold text-white mb-2 sm:mb-3 tracking-wide uppercase"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      🔹 Landing Page ad alta conversione
                    </h3>
                    <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                       style={{ fontFamily: 'Lato, sans-serif' }}>
                      Realizziamo pagine di atterraggio pensate per convertire visitatori in clienti.
                      Ideali per campagne pubblicitarie, eventi, lanci prodotto o lead generation.
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-6 sm:p-8 rounded-2xl shadow-md border border-white/20 hover:bg-[#36090d]/25 hover:border-[#36090d]/50 transition-all duration-300">
                <div className="flex items-start mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#e97e89]/20 rounded-2xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-apps-line text-lg sm:text-xl text-[#e97e89]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-extrabold text-white mb-2 sm:mb-3 tracking-wide uppercase"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      🔹 Web App e piattaforme su misura
                    </h3>
                    <p className="text-sm sm:text-base text-white/90 leading-relaxed"
                       style={{ fontFamily: 'Lato, sans-serif' }}>
                      Sviluppiamo soluzioni personalizzate per la gestione interna, CRM aziendali, portali clienti e sistemi interattivi.
                      Tecnologie utilizzate: HTML5, CSS3, JavaScript, React, PHP, Laravel, Node.js.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#36090d] to-[#e97e89] p-6 sm:p-8 lg:p-10 rounded-2xl shadow-2xl">
              <h3 className="text-xl sm:text-2xl font-extrabold text-white mb-4 sm:mb-6 text-center tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                ✨ Perché scegliere Orvia per il tuo sito web
              </h3>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>Siti 100% responsive, ottimizzati per desktop, tablet e mobile</span>
                </div>
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>Codice pulito e performante, per tempi di caricamento ridotti</span>
                </div>
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>SEO integrata sin dalla fase di sviluppo</span>
                </div>
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>Design personalizzato in base alla tua brand identity</span>
                </div>
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>Gestione autonoma tramite CMS (WordPress o custom)</span>
                </div>
                <div className="flex items-start text-white">
                  <i className="ri-check-line text-xl sm:text-2xl mr-2 sm:mr-3 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base" style={{ fontFamily: 'Lato, sans-serif' }}>Manutenzione continua e assistenza tecnica post-lancio</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* UX/UI Design Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-8 tracking-wider uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  🎨 UX/UI Design & Brand Identity
                </h2>
                
                <p className="text-xl text-white/90 mb-8 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Il design non è solo estetica: è comunicazione.
                  Con Orvia, ogni elemento visivo viene progettato per trasmettere la personalità del tuo brand e migliorare l'esperienza dell'utente.
                </p>

                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#e97e89] text-xl mr-3 mt-1"></i>
                    <p className="text-white/90" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Analisi dell'esperienza utente (UX) per migliorare la navigazione e l'interazione
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#e97e89] text-xl mr-3 mt-1"></i>
                    <p className="text-white/90" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Creazione di interfacce (UI) moderne, accessibili e intuitive
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#e97e89] text-xl mr-3 mt-1"></i>
                    <p className="text-white/90" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Definizione della brand identity, loghi, palette colori e tipografia
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#e97e89] text-xl mr-3 mt-1"></i>
                    <p className="text-white/90" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Prototipi e wireframe per testare il percorso utente prima dello sviluppo
                    </p>
                  </div>
                </div>

                <div className="mt-8 p-6 rounded-2xl shadow-md border border-white/20 hover:bg-[#e97e89]/15 hover:border-[#e97e89]/50 transition-all duration-300">
                  <p className="text-white/90 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                    Ogni sito che creiamo segue una logica visiva coerente con il tuo messaggio.
                    Usiamo il colore principale <strong className="text-[#e97e89]">#36090d</strong> per trasmettere solidità e professionalità, 
                    accompagnato dai toni caldi di <strong className="text-[#e97e89]">#e97e89</strong> e <strong className="text-[#e97e89]">#f1b2b9</strong> per evocare eleganza e empatia.
                  </p>
                </div>
              </div>

              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/57a53bcc866131c6d051c02aaa6d2a94.jpg"
                  alt="Design UX/UI"
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Digital Advertising Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                📈 Campagne Pubblicitarie Digitali
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed"
                 style={{ fontFamily: 'Lato, sans-serif' }}>
                Con le giuste campagne, puoi raggiungere il tuo pubblico ideale e ottenere risultati misurabili.
                Orvia pianifica, crea e gestisce campagne pubblicitarie digitali multicanale con obiettivi chiari e KPI precisi.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 text-center transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-facebook-circle-fill text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg font-extrabold text-white mb-2 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Meta Ads
                </h3>
                <p className="text-white/90 text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>
                  Facebook, Instagram
                </p>
              </div>

              <div className="p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 text-center transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-google-fill text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg font-extrabold text-white mb-2 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Google Ads
                </h3>
                <p className="text-white/90 text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>
                  Search, Display, Shopping
                </p>
              </div>

              <div className="p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 text-center transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-linkedin-box-fill text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg font-extrabold text-white mb-2 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  LinkedIn Ads
                </h3>
                <p className="text-white/90 text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>
                  B2B
                </p>
              </div>

              <div className="p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 text-center transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-music-2-fill text-2xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-lg font-extrabold text-white mb-2 tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  TikTok Ads
                </h3>
                <p className="text-white/90 text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>
                  Target giovane e dinamico
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-[#36090d]/95 to-[#e97e89]/95 backdrop-blur-sm">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 tracking-wider uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Pronto a trasformare la tua presenza digitale?
            </h2>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed"
               style={{ fontFamily: 'Lato, sans-serif' }}>
              Contattaci oggi per una consulenza gratuita e scopri come possiamo aiutarti a raggiungere i tuoi obiettivi online.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contatti" className="bg-white text-[#36090d] px-8 py-4 rounded-2xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-md hover:shadow-lg transform hover:-translate-y-1">
                Richiedi una consulenza gratuita
              </a>
              <a href="/contatti" className="border-2 border-white text-white px-8 py-4 rounded-2xl font-semibold hover:bg-white hover:text-[#36090d] transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-md hover:shadow-lg transform hover:-translate-y-1">
                Chiama ora: +39-3518712315
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="text-white py-16 border-t border-white/20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <img 
                  src="https://static.readdy.ai/image/448d3dd4920f14db0013cfc0f3d75a62/51fa198fcc5d92a2ecc7c07e6e02f260.png"
                  alt="Orvia Logo"
                  className="h-8 mb-4"
                />
                <p className="text-white/80 mb-6 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  La tua agenzia digitale di fiducia per lo sviluppo web, design e marketing digitale. 
                  Trasformiamo le tue idee in successi online.
                </p>
                <div className="flex space-x-4">
                  <a href="https://www.instagram.com/orvia.it?igsh=bGJwNXVva3VxdTM4" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#e97e89] rounded-full flex items-center justify-center hover:bg-[#36090d] transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-white"></i>
                  </a>
                  <a href="https://www.tiktok.com/@orvia.com?_r=1&_t=ZN-93GUTAQtSeE" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#e97e89] rounded-full flex items-center justify-center hover:bg-[#36090d] transition-colors cursor-pointer">
                    <i className="ri-tiktok-line text-white"></i>
                  </a>
                </div>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4 tracking-wide uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Servizi
                </h4>
                <ul className="space-y-2 text-white/80">
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Sviluppo Web</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Design UX/UI</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Social Media</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">SEO & Marketing</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Copywriting</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4 tracking-wide uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Contatti
                </h4>
                <ul className="space-y-2 text-white/80">
                  <li className="flex items-center">
                    <i className="ri-mail-line mr-2"></i>
                    OrviaClient@gmail.com
                  </li>
                  <li className="flex items-center">
                    <i className="ri-phone-line mr-2"></i>
                    +39-3518712315
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-white/60 text-sm">
                © 2024 Orvia. Tutti i diritti riservati.
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="#" className="text-white/60 hover:text-[#e97e89] text-sm transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
